// src/hooks/useLanguage.js
import { useContext } from 'react';
import { LanguageContext } from '../App';

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return { lang: 'en', t: (key) => key };
  }
  return ctx;
}
